<template>
    <div class="center_main_title_box">
        <!-- 查看更多 -->
        <a href="javascript:;" 
            class="center_main_title_more"
            @click="learnMore">
            {{$t("message.cmain.more")}}
            <i class="el-icon-arrow-right"></i>
        </a>
        <div class="center_main_title_content">{{title}}</div>
    </div>
</template>

<script>
export default {
    props: [ "learnMore", "title" ]
}
</script>

<style scoped>
.center_main_title_box{
    padding: 10px 20px;
    border-bottom: 1px solid #DCDFE6;
}
/* 查看更多 */
.center_main_title_more{
    float: right;
    color: #909399
}
.center_main_title_more:hover{
    color: #FF6700;
}
/* 标题 */
.center_main_title_content{
    font-size: 15px;
    font-weight: bold;
    color: #303133;
}
</style>
